// @ './definition' or its correspon... Remove this comment to see the full error message
import definition from './definition.json';
import presets from './Presets';

export default { definition, presets };
